import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import Input from '../../../../../ui/canon/Input';
import { SendIcon, LinkIcon } from 'lucide-react';

const UrlWidget = ({
  onAnswer,
  disabled,
  placeholder = 'Enter URL (e.g., https://example.com)...',
  initialValue = '',
}) => {
  const [value, setValue] = useState(initialValue || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setValue(initialValue || '');
    setIsSubmitting(false);
    setError('');
  }, [initialValue]);

  const validateUrl = (url) => {
    if (!url.trim()) return '';

    // Add https:// if no protocol specified
    let testUrl = url;
    if (!/^https?:\/\//i.test(url)) {
      testUrl = `https://${url}`;
    }

    try {
      new URL(testUrl);
      return '';
    } catch {
      return 'Please enter a valid URL';
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (error) {
      setError(validateUrl(newValue));
    }
  };

  const handleBlur = () => {
    setError(validateUrl(value));
  };

  const handleSubmit = () => {
    const validationError = validateUrl(value);
    if (validationError) {
      setError(validationError);
      return;
    }

    if (value.trim() && !isSubmitting) {
      setIsSubmitting(true);
      // Normalize URL with protocol if missing
      let finalValue = value.trim();
      if (!/^https?:\/\//i.test(finalValue)) {
        finalValue = `https://${finalValue}`;
      }
      onAnswer({ value: finalValue });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const isValid = value.trim() && !validateUrl(value);

  return (
    <div className="space-y-3">
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-succession-text-muted">
          <LinkIcon className="h-4 w-4" />
        </div>
        <Input
          type="url"
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled || isSubmitting}
          className="pl-10"
        />
      </div>
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
      <Button
        onClick={handleSubmit}
        disabled={!isValid || disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        Submit Answer
      </Button>
    </div>
  );
};

export default UrlWidget;
